import React from "react";
import { Box, Grid, Paper } from "@mui/material";
import ErrorIcon from "@mui/icons-material/Error";

import RpAlert from "@/components/alerts/RpAlert";
import JoinCampaignLocationName from "@/features/campaigns/components/joinCampaignCommon/JoinCampaignLocationName";
import { formatNationalPlusUpLocationDisplayName } from "../utils/nationalPlusUpHelpers";

type NationalPlusUpLocation = Record<string, any>;

type NationalPlusUpNotEligibleLocationsProps = {
  locations?: NationalPlusUpLocation[];
};

function NationalPlusUpNotEligibleLocations({
  locations = [],
}: NationalPlusUpNotEligibleLocationsProps) {
  if (!locations?.length) {
    return (
      <Box sx={{ p: 2, mt: 20, display: "flex", justifyContent: "center" }}>
        <RpAlert severity="info">There are no Not Eligible Locations</RpAlert>
      </Box>
    );
  }

  return (
    <div>
      {locations.map((location) => (
        <Paper
          key={location.id || location.location_id}
          sx={{ p: 1, mt: 1 }}
          elevation={2}
        >
          <Grid
            container
            spacing={2}
            justifyContent="space-between"
            alignItems="center"
          >
            <Grid>
              <JoinCampaignLocationName>
                <ErrorIcon
                  color="error"
                  className="mr-1"
                  titleAccess="Not Eligible"
                />
                {formatNationalPlusUpLocationDisplayName(location)}
              </JoinCampaignLocationName>
            </Grid>
            {location.eligibility_reason ? (
              <Grid>
                <Box sx={{ textAlign: "right" }}>
                  <RpAlert severity="warning">
                    {location.eligibility_reason}
                  </RpAlert>
                </Box>
              </Grid>
            ) : null}
          </Grid>
        </Paper>
      ))}
    </div>
  );
}

export default NationalPlusUpNotEligibleLocations;
